import { Pipe, PipeTransform } from '@angular/core';
import { normalizeBreedName } from '../models/dog-breed.models';

/** Keeps every dog-breed label consistent, regardless of its import casing. */
@Pipe({ name: 'breedName', standalone: true, pure: true })
export class BreedNamePipe implements PipeTransform {
  transform(value?: string | null): string {
    return value?.trim() ? normalizeBreedName(value) : '';
  }
}
